import React, { useEffect, useState } from "react";
import SubNavBar from "../../../components/Settings/Sub/TabPicker";
import MyDetails from "../../../components/Settings/Tabs/MyDetails";
import Password from "../../../components/Settings/Tabs/Password";
import Notifications from "../../../components/Settings/Tabs/Notifications";
import API from "../../../components/Settings/Tabs/Api";
const ClientSettings = () => {
  useEffect(() => {
    document.title = "Snilink - Settings";
  }, []);
  const [activeTab, setActiveTab] = useState("my-details");
  let activeComponent;
  switch (activeTab) {
    case "my-details":
      activeComponent = <MyDetails />;
      break;
    case "password":
      activeComponent = <Password />;
      break;
    case "notifications":
      activeComponent = <Notifications />;
      break;
    case "api":
      activeComponent = <API />;
      break;
    default:
      activeComponent = null;
  }
  return (
    <>
      <h1 className="m-0 text-primary-900 dark:text-accent-100 text-2xl font-semibold mb-16px">
        Settings
      </h1>
      <SubNavBar active={activeTab} setActiveTab={setActiveTab} />
      {activeComponent}
    </>
  );
};
export default ClientSettings;
